import { Box, Stack } from "@mui/material";
import type { JSX } from "react";
import { IUICustomizationPresetDescriptionDTO } from "../../../services/ui-customization-data-service/Models";

export type UICustomizationPresetSubheaderProps = {
    preset: IUICustomizationPresetDescriptionDTO;
};

export default function UICustomizationPresetSubheader({
    preset
}: UICustomizationPresetSubheaderProps): JSX.Element {
    return (
        <>
            <Stack direction="row">
                {preset.description &&
                    <Box
                        sx={{
                            color: "primary",
                            fontStyle: "italic",
                            flex: "1 1 auto"
                        }}>
                        {`${preset.description}`}
                    </Box>
                }
            </Stack>
        </>
    );
}
